/* unplugin-vue-components disabled */import script from "./mg-list-page.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-list-page.vue?vue&type=script&setup=true&lang=js"

import "./mg-list-page.vue?vue&type=style&index=0&id=21d2fa62&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d2fa62"]])

export default __exports__